.root {
  display: flex;
  position: relative;
  padding: var(--spacing-ds-3);
  border-width: var(--border-ds-width-hairline);
  border-radius: var(--radius-ds-md);
}

.body {
  flex-grow: var(--flex-ds-grow-fill);
}

.title {
  display: block;
  font-weight: var(--font-weight-ds-medium);
}

.title-sm {
  font-size: var(--text-ds-label);
  line-height: var(--text-ds-label--line-height);
}

.title-md {
  font-size: var(--text-ds-body);
  line-height: var(--text-ds-body--line-height);
}

.description {
  display: block;
  margin-top: var(--spacing-ds-1);
  font-size: var(--text-ds-caption);
  line-height: var(--text-ds-caption--line-height);
}

.check {
  flex-shrink: var(--flex-ds-shrink-none);
  width: var(--size-ds-icon-md);
  height: var(--size-ds-icon-md);
}
